import React, { useState, useRef } from "react";
import Container from "./container";
import FigureG from "./figure-g";
import { cn, handleize } from "../lib/helpers";

import * as styles from "../styles/components/fc-multi-cards.module.css";

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
  _rawCaption?: any[];
}

interface CardItem {
  _key?: string;
  title?: string;
  image?: ImageAsset;
}

interface MultiCardsProps {
  title?: string;
  cards?: CardItem[];
}

const MultiCards: React.FC<MultiCardsProps> = ({ title, cards }) => {
  if (!cards || cards.length === 0) {
    return null;
  }

  const ref = useRef(null);
  const [selectedCard, setSelectedCard] = useState(cards[0].title);

  const handleChange = (title) => {
    setSelectedCard(title);
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div className={styles.root} ref={ref}>
      <Container>
        <div className="grid">
          <div className="col-lg-4">
            {title && (<h2 className={styles.title}>{title}</h2>)}

            <div className={styles.toggles}>
              {cards.map(({ _key, title }) => (
                <div className={styles.toggle} key={_key}>
                  <input 
                    type="radio" 
                    name="card" 
                    id={`card-${handleize(title)}`} 
                    value={title} 
                    checked={selectedCard === title}
                    onChange={() => handleChange(title)}
                  />
                  <h3 className={cn("h4", styles.subtitle)}><label htmlFor={`card-${handleize(title)}`} >{title}</label></h3>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-7 offset-lg-1">
            <div className={styles.items}>
              {cards.map(({ _key, title, image }) => (
                <div className={cn(styles.item, selectedCard === title && styles.active)} key={_key}>
                  <h3 className={cn("h4", styles.subtitle)}>{title}</h3>
                  <FigureG node={image} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MultiCards;
